import styled from "styled-components";
import Icon from "app/components/shared/Icon";
import FriendlyTime from "app/components/shared/FriendlyTime";
import BuildNumber from "./BuildNumber";
import { TestPlanProps } from "../type";
import TestPlansDropdown from "./TestPlansDropdown";
import CommitSha from "./CommitSha";
import Branch from "./Branch";

type MetadataRowProps = {
  buildNumber: string | null | undefined;
  buildUrl: string | null | undefined;
  commitSha?: string | null | undefined;
  branch: string | null | undefined;
  createdAt: string;
  testPlans?: TestPlanProps[];
  repoUrl?: string | undefined | null;
  linkToBranchTag?: boolean;
};

export const Separator = () => <span>&middot;</span>;

const MetadataRow = ({
  buildNumber,
  buildUrl,
  commitSha,
  branch,
  createdAt,
  testPlans,
  repoUrl,
  linkToBranchTag,
}: MetadataRowProps) => (
  <div className="flex flex-wrap items-center gap-x-2 max-w-full">
    {(buildNumber || buildUrl) && (
      <>
        <span data-testid="build-number">
          <BuildNumber number={buildNumber} url={buildUrl} />
        </span>

        <Separator />
      </>
    )}

    {(branch || commitSha) && (
      <>
        <span className="flex flex-wrap items-center gap-x-0.5 truncate">
          {branch && <Branch branch={branch} linkToBranchTag={linkToBranchTag} />}

          {branch && commitSha && (
            <Icon icon="custom/outline/20x/slash" style={{ height: 14, width: 14 }} />
          )}

          {commitSha && (
            <span data-testid="commit-sha">
              <CommitSha commitSha={commitSha} repoUrl={repoUrl} />
            </span>
          )}
        </span>

        <Separator />
      </>
    )}

    {testPlans && testPlans.length > 0 && (
      <>
        <TestPlansDropdown testPlans={testPlans} />

        <Separator />
      </>
    )}

    <FriendlyTime value={createdAt} />
  </div>
);

export default MetadataRow;
